import { useEffect, useState } from "react";
import { agentApi } from "../../../api/client";
import { COLORS } from "../../../theme/colors";

// Shared by PipelineTab (B9) and ActivityTab (B11). Polls
// /api/supervisor/killswitch/status every 5s; admin Reset button when active.

export default function KillSwitchIndicator({ canMutate }) {
  const [status, setStatus] = useState(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  const refresh = async () => {
    try {
      const res = await agentApi.killSwitchStatus();
      setStatus(res?.data || null);
      setErr(null);
    } catch (e) {
      setErr(e?.message || String(e));
    }
  };

  useEffect(() => {
    refresh();
    const t = setInterval(refresh, 5000);
    return () => clearInterval(t);
  }, []);

  if (err) {
    return (
      <div style={{
        padding: "10px 14px", borderRadius: 10,
        border: `1px solid ${COLORS.border}`, background: COLORS.surface,
        fontSize: 11, color: COLORS.textDim,
      }}>Kill-switch status unavailable: {err}</div>
    );
  }

  const active = !!status?.active;
  const color = active ? COLORS.pink : COLORS.green;
  const label = active ? "L3 KILL-SWITCH ACTIVE — traffic on L2-only" : "L3 active — pipeline healthy";

  const onReset = async () => {
    if (!confirm(`Reset L3 kill-switch?\n\nLast trip reason:\n${status?.reason || "(none)"}\n\nResetting will resume L1–L3 routing.`)) return;
    setBusy(true);
    try {
      await agentApi.killSwitchReset();
      await refresh();
    } catch (e) {
      setErr(e?.message || String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{
      padding: "10px 14px", borderRadius: 10,
      border: `1px solid ${color}55`,
      background: `linear-gradient(90deg, ${color}18 0%, transparent 80%)`,
      display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap",
    }}>
      <span style={{
        width: 10, height: 10, borderRadius: "50%",
        background: color, boxShadow: `0 0 10px ${color}88`,
      }} />
      <span style={{ fontSize: 12, fontWeight: 600, color }}>{label}</span>
      {status && (
        <span style={{ fontSize: 10, color: COLORS.textDim, fontFamily: "monospace" }}>
          breach_threshold={status.breach_threshold} window={status.breach_window_seconds}s
          {status.tripped_at_iso ? ` · tripped_at=${status.tripped_at_iso}` : ""}
        </span>
      )}
      {active && status?.reason && (
        <span style={{ fontSize: 11, color: COLORS.text, fontStyle: "italic", flex: "1 1 100%" }}>
          reason: {status.reason}
        </span>
      )}
      {active && canMutate && (
        <button onClick={onReset} disabled={busy} style={{
          marginLeft: "auto", background: color, color: "#fff", border: "none",
          padding: "5px 12px", borderRadius: 6, cursor: busy ? "wait" : "pointer", fontSize: 11, fontWeight: 600,
        }}>{busy ? "Resetting…" : "Reset"}</button>
      )}
    </div>
  );
}
